import IztScrollContent from './src/izt-scroll-content'

IztScrollContent.install = Vue => {
  Vue.component(IztScrollContent.name, IztScrollContent)
}

export default IztScrollContent